import React, {useState} from 'react';
import { Button, Row, Col, Card } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons";
 
import Rightbar from './Rightbar';
import {Link } from 'react-router-dom';


export default function Artwork(){ 
    const [sidebar, setsidebar] = useState(false);
    const [mainbar, setmainbar] = useState(false);
    const toggle = () => {
        setsidebar(!sidebar);
        setmainbar(!mainbar);
    }
    return(
  <>
<section className="sec-container" >
   <div className='container'>
      <div className='portalevent'>
         <div className='row'>
         <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                  <div >
                  <Rightbar/>
                  </div>
               </div>
               <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                  <div className='rightbar '>
                  <Button variant="outline-info" onClick={toggle}>
                    <FontAwesomeIcon icon={faAlignLeft} />
                  </Button>
                  <h1>YOUR ARTWORK</h1>
                  <p>Click image to edit artwork details.</p>
                <Row xs={1} md={4} className="g-4 mb-3 artlisting" >
                    <Col>
                        <Card style={{"textAlign" : "center"}}>
                            <Link to="">
                            <Card.Img variant="top" src={process.env.PUBLIC_URL+'/images/default-img.png'} /> 
                            </Link>
                            <Card.Body>
                                <Card.Title>UNTITLED</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{"textAlign" : "center"}}>
                        <Card.Img variant="top" src={process.env.PUBLIC_URL+'/images/default-img.png'} /> 
                            <Card.Body>
                                <Card.Title>UNTITLED</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{"textAlign" : "center"}}>
                        <Card.Img variant="top" src={process.env.PUBLIC_URL+'/images/default-img.png'} /> 
                            <Card.Body>
                                <Card.Title>UNTITLED</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{"textAlign" : "center"}}>
                        <Card.Img variant="top" src={process.env.PUBLIC_URL+'/images/default-img.png'} /> 
                            <Card.Body>
                                <Card.Title>UNTITLED</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{"textAlign" : "center"}}>
                        <Card.Img variant="top" src={process.env.PUBLIC_URL+'/images/default-img.png'} /> 
                            <Card.Body>
                                <Card.Title>UNTITLED</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{"textAlign" : "center"}}>
                        <Card.Img variant="top" src={process.env.PUBLIC_URL+'/images/default-img.png'} /> 
                            <Card.Body>
                                <Card.Title>UNTITLED</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{"textAlign" : "center"}}>
                        <Card.Img variant="top" src={process.env.PUBLIC_URL+'/images/default-img.png'} /> 
                            <Card.Body>
                                <Card.Title>UNTITLED</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{"textAlign" : "center"}}>
                        <Card.Img variant="top" src={process.env.PUBLIC_URL+'/images/default-img.png'} /> 
                            <Card.Body>
                                <Card.Title>UNTITLED</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card style={{"textAlign" : "center"}}>
                        <Card.Img variant="top" src={process.env.PUBLIC_URL+'/images/default-img.png'} /> 
                            <Card.Body>
                                <Card.Title>UNTITLED</Card.Title>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <div className='text-center'>
                <Link to="/addartwork"><Button className='common-btn'>Add Artwork</Button></Link>
                </div>
                  <br/>
                            </div>
                            </div>
 
                  </div>
            </div>
         </div>
       
</section>  

 
</>
)
}
